import { AxiosError } from "axios";
import { ReactElement } from "react";
import toast from "react-hot-toast";

type ToastId = string;

const TIMEOUT_DELAY = 0;
const ERROR_PROBABILITY = 0;

const getLayout = (title: string, message: string): ReactElement => (
  <div>
    <strong>{title}</strong>
    <div>{message}</div>
  </div>
);

export const handleApiError = (e: AxiosError<{ message: string, error: string }> | unknown) => {
    console.error(e);
    try {
      const AxiosError = e as AxiosError<{ message: string, error: string }>;
      toast.error(AxiosError.response?.data.error || AxiosError.response?.data.message || 'Error occured... Please try again.');
    }
    catch {
      const err = e as Error;
      if (err?.message) {
        toast.error(err.message);
      }
      else {
        toast.error('Error occured... Please try again.');
      }
    }
}

// toastr

export const startPersistentInfoToast = (title: string, message: string): ToastId => {
  return toast(getLayout(title, message), { duration: Infinity, icon: 'ℹ️' });
};

export const stopPersistentInfoToast = (toastId: ToastId, errorMessage?: string) => {
  toast.dismiss(toastId);
  errorMessage && toast.error(errorMessage);
};

// api

export function addFormValues<T extends Record<string, unknown>>(formValues: T, apiFormData: FormData) {

  if (formValues.file != null) {
    apiFormData.append('file', formValues.file as File);
    delete formValues.file;
  }

  (Object.keys(formValues) as Array<keyof T>).forEach((key) => {
    const value = formValues[key];
    
    if (value !== undefined) {
      if (value === null) {
        apiFormData.append(key as string, '__null__');
      }
      else if ((typeof value === 'object') && value !== null) {
        apiFormData.append(key as string, JSON.stringify(value));
      }
      else if (value?.toString() != null) {
        apiFormData.append(key as string, value.toString());
      }
    }
  });
}

export const simulate = async (options?: SimulationOptions) => {
  const { 
    timeoutOverride = TIMEOUT_DELAY, 
    errorProbability = ERROR_PROBABILITY 
  } = options || {};

  await new Promise<void>((resolve, reject) => {
    setTimeout(() => {
      if (Math.random() < errorProbability) {
        reject(new Error('Simulated error'));
      } else {
        resolve();
      }
    }, timeoutOverride);
  });
};

type SimulationOptions = {
  timeoutOverride?: number;
  errorProbability?: number;
};
